import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ['menu'];

  connect() {
    this.cleanup();
    this.initOffcanvas();

    this.resizeObserver = new ResizeObserver(() => {
      this.initOffcanvas();
    });
    this.resizeObserver.observe(document.body);
  }

  initOffcanvas() {
    const breakpoint = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-lg').trim();
    const isMobile = window.innerWidth < parseInt(breakpoint);
    const instance = bootstrap.Offcanvas.getInstance(this.menuTarget);

    if (instance) instance.dispose();

    this.offcanvas = new bootstrap.Offcanvas(this.menuTarget, {
      backdrop: false,
      scroll: !isMobile,
    });

    if (this.handleOutsideClick) {
      document.removeEventListener('click', this.handleOutsideClick);
    }

    this.handleOutsideClick = (event) => {
      if (this.offcanvas._isShown
        && !this.menuTarget.contains(event.target)
        && !event.target.closest('[data-action*="toggle"]')) {
        this.offcanvas.hide();
      }
    };

    document.addEventListener('click', this.handleOutsideClick);
  }

  toggle(event) {
    event.preventDefault();
    this.offcanvas.toggle();
  }

  cleanup() {
    const instance = bootstrap.Offcanvas.getInstance(this.menuTarget);
    if (instance) instance.dispose();

    this.menuTarget.classList.remove('show', 'hiding', 'showing');
    document.body.classList.remove('offcanvas-open');
    document.querySelectorAll('.offcanvas-backdrop').forEach(b => b.remove());

    if (this.handleOutsideClick) {
      document.removeEventListener('click', this.handleOutsideClick);
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  disconnect() {
    this.cleanup();
  }
}
